export default __webpack_public_path__ + "static/media/menu.4b2121d0.svg";